import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { Helmet } from 'react-helmet';

const TermsOfService = () => {
  return (
    <Container sx={{ paddingTop: 4 }}>
      <Helmet>
        <title>Terms of Service | SalaryTools.co.uk</title>
        <meta name="description" content="Review the Terms of Service for SalaryTools.co.uk to understand the guidelines and rules for using our website and services." />
        <link rel="canonical" href="https://salarytools.co.uk/terms-of-service" />
      </Helmet>

      <Typography variant="h4" sx={{ marginBottom: 2 }}>
        Terms of Service
      </Typography>
      <Box>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Welcome to SalaryTools.co.uk. By accessing or using our services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our website.
        </Typography>

        <Typography variant="h6" sx={{ marginTop: 4 }}>
          1. Acceptance of Terms
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          By accessing or using our website and services, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, you should not use our website.
        </Typography>

        <Typography variant="h6">
          2. Use of the Website
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          You may use the website and its services only for lawful purposes. You agree not to engage in any activities that could harm, disable, overburden, or impair the website or interfere with any other party's use of the website.
        </Typography>

        <Typography variant="h6">
          3. User Responsibilities
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          You are responsible for maintaining the confidentiality of your account details and for all activities under your account. You agree to notify us immediately if you suspect any unauthorized use of your account.
        </Typography>

        <Typography variant="h6">
          4. Data Protection and Privacy
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          We are committed to protecting your privacy and personal data in compliance with the UK Data Protection Act 2018 and the General Data Protection Regulation (GDPR). Please refer to our <a href="/privacy-policy">Privacy Policy</a> for detailed information on how we collect, use, and protect your personal information.
        </Typography>

        <Typography variant="h6">
          5. Limitation of Liability
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          We shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from the use or inability to use our services, even if we have been advised of the possibility of such damages. Our liability is limited to the fullest extent permitted by law.
        </Typography>

        <Typography variant="h6">
          6. Termination
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          We reserve the right to suspend or terminate your access to the website and services at our discretion, without notice, if we believe you have violated these terms, or for any other reason we deem necessary.
        </Typography>

        <Typography variant="h6">
          7. Changes to Terms
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          We may update these Terms of Service from time to time. Any changes will be posted on this page, and the revised terms will have an updated effective date. We encourage you to review these terms periodically to stay informed of any changes.
        </Typography>

        <Typography variant="h6">
          8. Third-Party Links
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Our website may contain links to third-party websites or services. We are not responsible for the content, privacy policies, or practices of any third-party websites. We recommend reviewing the privacy policies and terms of service of any third-party websites you visit.
        </Typography>

        <Typography variant="h6">
          9. Governing Law
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          These Terms of Service shall be governed by and construed in accordance with the laws of the United Kingdom. Any disputes arising from these terms will be subject to the exclusive jurisdiction of the UK courts.
        </Typography>

        <Typography variant="h6">
          10. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          If you have any questions about these Terms of Service, please contact us at [insert contact information].
        </Typography>

        <Typography variant="body2" sx={{ marginTop: 4 }}>
          Last Updated: 16th February 2025
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsOfService;
